import React from "react";
import "../App.css";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

export interface TitleData {
  title: string;
  color: string;
}

const useStyles = makeStyles({
  root: {
    display: "grid",
    alignItems: "start",
  },
  title: {
    gridColumnStart: 1,
    gridRowStart: 1,
  },
  highlight: {
    gridColumnStart: 1,
    gridRowStart: 1,
    width: "110%",
    height: "1.3em",
    background: "transparent",
    margin: "0.5em",
  },
});

export default function HighlightTitle({ title, color }: TitleData) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.highlight} style={{ background: color }} />
      <Typography component="h4" variant="h4" className={classes.title}>
        {title}
      </Typography>
    </div>
  );
}
